<div class="card_image">
	<img *ngIf="src" [src]="src" alt="user's profile picture" />
	<div *ngIf="!src" class="no-image">
		No profile image
	</div>
</div>
